import React from 'react';

const ObservationContent = ({ observation }) => {
    if (!observation) return null;

    return (
        <>
            <tr>
                <td className={'border-0 table-break-word final-boxReadjust'} colSpan={12}>
                    <div className={'mt-[-20px]'}>
                        <div className={'obs-title'}><span>Observação final do plantão</span></div>
                        <div className="obs-box-final mb-[25px]">{observation}</div>
                    </div>
                </td>
            </tr>
        </>
    );
};

export default ObservationContent;